module.exports = __webpack_public_path__ + "static/Inter-Black-09073bae9fc5d2c931a076f1100f76bb.woff";